import { useState, useCallback } from "react"

import { v4 } from "uuid"

export const useEventSession = () => {
  const [eventSessions, setEventSessions] = useState<{ [key: string]: string }>({})

  const startSession = useCallback((eventSessionName: string) => {
    setEventSessions((sessions) => {
      if (sessions[eventSessionName]) {
        return sessions
      }
      return {
        ...sessions,
        [eventSessionName]: `cid:${eventSessionName}:${v4()}`,
      }
    })
  }, [])

  const endSession = useCallback((eventSessionName: string) => {
    setEventSessions((sessions) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [eventSessionName]: _, ...rest } = sessions
      return {
        ...rest,
      }
    })
  }, [])

  const getSession = useCallback(
    (eventSessionName: string) => {
      startSession(eventSessionName)
      const { [eventSessionName]: session } = eventSessions
      return session
    },
    [eventSessions, startSession],
  )
  return { eventSessions, startSession, endSession, getSession }
}
